import type { ParseKeys } from "i18next";
import type { FormikProps } from "formik";
import { useTranslation } from "react-i18next";

import { RadioButton } from "@components/formControls/radioButton";

interface IProps<T, TU extends keyof T> {
  name: TU;
  title: ParseKeys<"form">;
  value: FormikProps<T>["values"][TU];
  formik: FormikProps<T>;
  onChange?: (value: FormikProps<T>["values"][TU]) => void;
  // TODO: eslint check
  // readonly?: boolean
  // disabled?: boolean
}

export function FastRadio<T, TU extends keyof T>(props: IProps<T, TU>) {
  const name = props.name;
  const { values, setFieldValue /* errors, touched, handleBlur*/ } =
    props.formik;
  const selectedValue = values[name] as string;
  const value = props.value as string;
  const { t } = useTranslation("form");
  const title = props.title;

  return (
    <RadioButton
      label={t(title)}
      value={value}
      onChange={() => {
        setFieldValue(name.toString(), props.value);
        props?.onChange?.(props.value);
      }}
      selectedValue={selectedValue}
    />
  );
}
